export default __webpack_public_path__ + "static/media/AfterPhoto8.f67fa0ad.jpg";